'use client';

import { Quote } from 'daskapital-ds';
import classNames from 'classnames';

export type IBlockCitation = {
	attrs: {
		value?: string;
		author?: string;
		source?: string;
		sourceUrl?: string;
		anchor?: string;
		className?: string;
		animation?: string;
	};
};

export default function BlockCitation({ attrs }: IBlockCitation) {
	const { value, author, source, sourceUrl, anchor, className, animation } = attrs || {};

	return (
		<Quote
			id={anchor || undefined}
			className={classNames(className, animation && `elements_animated ${animation}`)}
			value={value}
			author={author}
			source={source}
			sourceUrl={sourceUrl}
		/>
	);
}
